/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Likes_viewer = {
    readonly favoriteNotifications?: {
        readonly id: string;
        readonly hasNewEvents: boolean | null;
    } | null;
    readonly favoriteNotificationsTiles?: {
        readonly " $fragmentRefs": FragmentRefs<"FavNotifications_favoriteNotificationsTiles">;
    } | null;
    readonly " $refType": "Likes_viewer";
};
export type Likes_viewer$data = Likes_viewer;
export type Likes_viewer$key = {
    readonly " $data"?: Likes_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Likes_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "createdAfter",
  "variableName": "createdAfter"
},
v2 = {
  "kind": "Variable",
  "name": "eventsLimit",
  "variableName": "eventsLimit"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "createdAfter"
    },
    {
      "defaultValue": 0,
      "kind": "LocalArgument",
      "name": "eventsLimit"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchNewEvents"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchNotifications"
    },
    {
      "defaultValue": 0,
      "kind": "LocalArgument",
      "name": "notificationItemsLimit"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Likes_viewer",
  "selections": [
    {
      "condition": "fetchNewEvents",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": (v0/*: any*/),
          "concreteType": "FavoriteNotifications",
          "kind": "LinkedField",
          "name": "favoriteNotifications",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                (v1/*: any*/),
                (v2/*: any*/)
              ],
              "kind": "ScalarField",
              "name": "hasNewEvents",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "fetchNotifications",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "favoriteNotificationsTiles",
          "args": (v0/*: any*/),
          "concreteType": "FavoriteNotifications",
          "kind": "LinkedField",
          "name": "favoriteNotifications",
          "plural": false,
          "selections": [
            {
              "args": [
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "kind": "Variable",
                  "name": "notificationItemsLimit",
                  "variableName": "notificationItemsLimit"
                }
              ],
              "kind": "FragmentSpread",
              "name": "FavNotifications_favoriteNotificationsTiles"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();
(node as any).hash = 'f61435e6e8cad92af85cd8418309071f';
export default node;
